<script lang="ts">
  import { goto } from '$app/navigation';
  import { browser } from '$app/environment';
  import { page, navigating } from '$app/stores';
  import CloseIcon from '$icons/CloseIcon.svelte';
  import HamburgerMenuIcon from '$icons/HamburgerMenuIcon.svelte';
  import ColosseumLogo from '$icons/logos/ColosseumLogoWhite.svelte';
  import { sideNavOpen } from '$stores';
  import Avatar from '$components/reusable/images/Avatar.svelte';
  import Button from '../Button.svelte';
  import { isPublicAuthRoute, isRouteAccessibleWithoutAuth } from '$lib/routing-utils';
  import { onMount } from 'svelte';
  import { client } from '$lib/api/Client';
  import NotificationBellIcon from '$icons/NotificationBellIcon.svelte';
  import NotificationsSlideOver from '../notifications/NotificationsSlideOver.svelte';

  let hasUnreadNotifications = false;
  let showNotifications = false;

  async function getUnreadNotifications() {
    try {
      // Don't unnecessarily poll before a user is onboarded
      if (!browser || !$page.data.user || !$page.data.user.agreementComplete) return;
      const notificationsResponse = await client.notifications.listNotifications();
      hasUnreadNotifications = notificationsResponse.notifications.some(
        (notification) => !notification.isRead,
      );
    } catch (error) {
      console.error('Error getting unread notifications', error);
    }
  }

  onMount(() => {
    getUnreadNotifications();
    const interval = setInterval(async () => {
      await getUnreadNotifications();
    }, 35000); // Poll for unread notifications every 35 seconds

    return () => {
      clearInterval(interval);
    };
  });
</script>

{#if showNotifications}
  <NotificationsSlideOver bind:showNotifications on:notificationsRead={getUnreadNotifications} />
{/if}

<div class="bg-gray-dark-0 border-gray-dark-3 sticky top-0 z-20 h-[4rem] border-b">
  <div class="px-2xl py-lg mx-auto flex max-w-[1600px] items-center justify-between">
    <a
      href="/"
      class="lg:pl-1"
      on:click|preventDefault={() =>
        $page.url.pathname === '/signup' && !$page.data.username
          ? (window.location.href = 'https://colosseum.org')
          : goto('/', { invalidateAll: true })}
    >
      <ColosseumLogo class="w-[8.5rem] lg:w-[10rem]" />
    </a>
    {#if $page.data.username}
      <div class="-pr-1 text-gray-dark-12 flex items-center gap-x-4 md:pr-2">
        <button on:click={() => (showNotifications = !showNotifications)} class="relative">
          <!--  -->
          <NotificationBellIcon class="h-[1.35rem] w-[1.35rem] lg:mr-[0.35rem]" />
          {#if hasUnreadNotifications}
            <div class="bg-gray-dark-0 absolute -top-px right-0 rotate-45 rounded p-0.5 lg:mr-1.5">
              <div class=" h-[0.4rem] w-[0.4rem] rounded-sm bg-red-500"></div>
            </div>
          {/if}
        </button>
        <button
          class="h-8 w-8 overflow-hidden"
          on:click={() => goto(`/profiles/${$page.data.username}`)}
        >
          <Avatar src={$page.data.avatarUrl} seed={$page.data.username} />
        </button>

        <div class="flex lg:hidden">
          <Button tertiary icon on:click={() => ($sideNavOpen = !$sideNavOpen)}>
            {#if $sideNavOpen}
              <CloseIcon />
            {:else}
              <HamburgerMenuIcon />
            {/if}
          </Button>
        </div>
      </div>
    {:else if !$page.data.userId && isRouteAccessibleWithoutAuth($page.url.pathname) && !isPublicAuthRoute($page.url.pathname) && browser && !$navigating}
      <!-- Non-onboarded, non-signed up user (or logged out) -->
      <Button primary size="sm" class="lg:hidden " on:click={() => goto('/signup')}>Sign Up</Button>
      <Button primary size="md" class="hidden lg:flex" on:click={() => goto('/signup')}>
        Sign Up
      </Button>
    {/if}
  </div>
</div>
